/** @jsx jsx */
import { Component } from 'react';
import { cssMap, jsx } from '@compiled/react';
import AddIcon from '@atlaskit/icon/core/migration/add';
import { token } from '@atlaskit/tokens';
import { Item } from '../../item/main.tsx';

const styles = cssMap({
	root: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Temporary workaround to make Emotion and Compiled specificity mesh until `@atlaskit/menu` is migrated to Compiled.
		'&&': {
			backgroundColor: token('color.background.input.pressed'),
			borderTop: `2px solid ${token('color.border')}`,
			borderRadius: '0px 0px 4px 4px',
			height: '52px',
			alignItems: 'center',
			color: token('color.text'),
			'&:focus': {
				backgroundColor: token('color.background.accent.gray.subtlest'),
				border: 'none',
				borderTop: `2px solid ${token('color.border')}`,
			},
			'&:hover, &:focus': {
				backgroundColor: token('color.background.input'),
			},
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'[data-item-elem-before]': {
			color: token('color.text'),
		},
	},
});

type Props = {
	label: string;
	onClick: () => void;
};

// eslint-disable-next-line jira/react/no-class-components
export default class CreateBoardButton extends Component<Props> {
	static renderIcon() {
		// @ts-expect-error - TS2769 - No overload matches this call.
		return <AddIcon LEGACY_size="small" />;
	}

	render() {
		const { label, onClick } = this.props;

		return (
			<Item
				// @ts-expect-error - TS2322 - Type '{ onClick: () => void; text: string; before: () => Element; styles: (state: any) => { '&:focus': { backgroundColor: string; border: string; borderTop: string; }; '& [data-item-elem-before]': { marginRight: string; color: string; }; ... 5 more ...; alignItems: string; }; }' is not assignable to type 'IntrinsicAttributes & ItemProps'.
				onClick={onClick}
				text={label}
				before={CreateBoardButton.renderIcon}
				css={styles.root}
			/>
		);
	}
}
